import React from 'react'
import Card from '@mui/material/Card'
import Divider from '@mui/material/Divider'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import PropTypes from 'prop-types'
import { path, prop } from 'ramda'

import { CardHeader } from '~/components/Cards'
import TextLabelLoader from '~/components/TextLabelLoader'

function ShipmentDetailAddress ({ shippingAddress }) {
  const firstName = prop('firstName', shippingAddress)
  const lastName = prop('lastName', shippingAddress)
  const email = prop('email', shippingAddress)
  const phone = prop('mobile', shippingAddress)
  const address = prop('address', shippingAddress)
  const region = prop('region', shippingAddress)
  const city = prop('city', shippingAddress)
  const zipcode = prop('zipcode', shippingAddress)
  const country = path(['country', 'name'], shippingAddress)
  const longitude = prop('longitude', shippingAddress)
  const latitude = prop('latitude', shippingAddress)

  return (
    <Card>
      <CardHeader title="Shipping address" />
      <Divider />
      <CardContent>
        <Grid container={true} spacing={3}>
          <Grid item={true} xs={12} lg={6}>
            <TextLabelLoader label="First name">
              {firstName}
            </TextLabelLoader>
          </Grid>

          <Grid item={true} xs={12} lg={6}>
            <TextLabelLoader label="Last name">
              {lastName}
            </TextLabelLoader>
          </Grid>

          <Grid item={true} xs={12}>
            <TextLabelLoader label="Email">
              {email}
            </TextLabelLoader>
          </Grid>

          <Grid item={true} xs={12}>
            <TextLabelLoader label="Phone">
              {phone}
            </TextLabelLoader>
          </Grid>

          <Grid item={true} xs={12}>
            <TextLabelLoader label="Address">
              {address}
            </TextLabelLoader>
          </Grid>

          <Grid item={true} xs={12}>
            <TextLabelLoader label="Region">
              {region}
            </TextLabelLoader>
          </Grid>

          <Grid item={true} xs={12} lg={6}>
            <TextLabelLoader label="City">
              {city}
            </TextLabelLoader>
          </Grid>

          <Grid item={true} xs={12} lg={6}>
            <TextLabelLoader label="Zipcode">
              {zipcode}
            </TextLabelLoader>
          </Grid>

          <Grid item={true} xs={12}>
            <TextLabelLoader label="Country">
              {country}
            </TextLabelLoader>
          </Grid>

          <Grid item={true} xs={6}>
            <TextLabelLoader label="Longitude">
              {longitude}
            </TextLabelLoader>
          </Grid>

          <Grid item={true} xs={6}>
            <TextLabelLoader label="Latitude">
              {latitude}
            </TextLabelLoader>
          </Grid>

        </Grid>
      </CardContent>
    </Card>
  )
}

ShipmentDetailAddress.propTypes = {
  shippingAddress: PropTypes.object
}

export default ShipmentDetailAddress
